<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '保险费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="car" slot-scope="prop">
          <ChooseCar
            :isRadio="true"
            v-model="prop.form.car"
            :otherSearchData="{
              orgId,
              isCheckAuthVehicle: 1,
            }"
            @change="handleChange"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
import { insuranceCompanyOptions } from '@qx/utils/enum';
import {
  getUserInfo,
} from '@qx/utils/auth';
export default {
  props: {
    orgId: {
      type: Number,
    },
  },
  components: {
    ChooseCar,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '保险类型',
            value: 'certificatesInsuranceType',
            type: 'select',
            placeholder: '请选择保险类型',
            options: [
              {
                label: '交强险',
                value: 3,
              },
              {
                label: '商业险',
                value: 4,
              },
              {
                label: '资产险',
                value: 0,
              },
            ],
          },
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '起保日期',
            value: 'insuranceStartDate',
            placeholder: '请选择起保日期',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '终保日期',
            value: 'insuranceEndDate',
            placeholder: '请选择终保日期',
            type: 'date',
            width: '240px',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '保险公司',
            value: 'serviceName',
            type: 'select',
            placeholder: '请选择保险公司',
            options: insuranceCompanyOptions,
          },
          {
            label: '被保险人',
            value: 'agentCompany',
            type: 'input',
            placeholder: '请输入被保险人',
          },
          {
            label: '保单号',
            value: 'insuranceCode',
            type: 'input',
            placeholder: '请输入保单号',
          },
          {
            label: '费用日期',
            value: 'feeAscriptionDate',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '保费',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入保费',
          },
          {
            label: '费用说明',
            value: 'payRemark',
            type: 'input',
            placeholder: '请输入费用说明',
            attr: {
              type: 'textarea',
            },
          },
          {
            label: '上传附件',
            value: 'detailPic',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
          },
        ],
        rules: { // 表单验证规则
          car: [ // 车牌号码
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          certificatesInsuranceType: [ // 保险类型
            { required: true, message: '请选择保险类型', trigger: 'blur' },
          ],
          insuranceStartDate: [ // 起保日期
            { required: true, message: '请选择起保日期', trigger: 'blur' },
          ],
          insuranceEndDate: [ // 终保日期
            { required: true, message: '请选择终保日期', trigger: 'blur' },
          ],
          agentCompany: [ // 被保险人
            { required: true, message: '请输入被保险人', trigger: 'blur' },
          ],
          feeAscriptionDate: [ // 费用日期
            { required: true, message: '请选择费用日期', trigger: 'blur' },
          ],
          payAmt: [ // 保费
            { required: true, message: '请输入保费', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    setAgentCompany () {
      const userInfo = getUserInfo();
      this.$refs.customForm.setVal('agentCompany', userInfo.tenantName);
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          // 车牌号码
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          this.$refs.customForm.setVal(item);
          this.handleChange();
        } else { // 新增
          this.type = 'add';
          this.setAgentCompany();
        }
      });
    },

    handleChange () {
      const carInfo = this.$refs.customForm.getVal('car');
      const licenceTypeName = carInfo.licenceTypeName || ' ';
      this.$refs.customForm.setVal('licenceTypeName', licenceTypeName);
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车牌号码
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      form.busiType = form.certificatesInsuranceType;
      // 年审类型
      switch (String(form.certificatesInsuranceType)) {
        case '3':
          form.certificatesInsuranceTypeName = '交强险';
          break;
        case '4':
          form.certificatesInsuranceTypeName = '商业险';
          break;
        case '0':
          form.certificatesInsuranceTypeName = '资产险';
          break;
        default:
          form.certificatesInsuranceTypeName = '--';
          break;
      }
      // 起保日期
      form.insuranceStartDate = this.formatDate(form.insuranceStartDate);
      // 终保日期
      form.insuranceEndDate = this.formatDate(form.insuranceEndDate);
      // 费用日期
      form.feeAscriptionDate = this.formatDate(form.feeAscriptionDate);
      delete form.car;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
